import { storageUtils } from "#shared/lib/storage-utils.ts";

const ADMIN_CONSOLE_ROUTE_KEY = "gain_console";

function isSupportedRoute(route: string): boolean {
  return route.startsWith("/");
}

export function persistAdminConsoleRoute(route: string): void {
  const normalizedRoute = route.trim();
  if (!normalizedRoute || !isSupportedRoute(normalizedRoute)) {
    return;
  }
  storageUtils.set(ADMIN_CONSOLE_ROUTE_KEY, normalizedRoute);
}

export function loadAdminConsoleRoute(): string | null {
  const value = storageUtils.get(ADMIN_CONSOLE_ROUTE_KEY);
  if (!value || !isSupportedRoute(value)) {
    return null;
  }
  return value;
}

export function removeAdminConsoleRoute(): void {
  storageUtils.delete(ADMIN_CONSOLE_ROUTE_KEY);
}
